export default __webpack_public_path__ + "static/media/Bosa Chartering terms of conduct 2020.68e22d74.pdf";